import { z } from 'zod';

export const webhookDeliverySchema = z.object({
  id: z.string(),
  webhookId: z.string(),
  notificationId: z.string(),
  eventType: z.string(),
  statusCode: z.number().nullable(),
  success: z.boolean(),
  attempt: z.number(),
  createdAt: z.string(),
});
export type WebhookDelivery = z.infer<typeof webhookDeliverySchema>;
